<app-select
  [items]="enumItems()"
  [value]="selectedRawValue() || null"
  [openOnInit]="true"
  [clearable]="true"
  [style.min-width.px]="tableCellWidth()"
  (valueChange)="valueChange.emit($any($event))" />
